import { useNavigate } from "react-router-dom";

function CardImage({ movie }) {
  const navigate = useNavigate();
  function handleOnClick(id) {
    navigate(`/${id}?context=${movie.slug}`);
  }
  return (
    <div
      onClick={() => handleOnClick(movie.id)}
      className="flex flex-col justify-start cursor-pointer place-items-center w-80 my-3 rounded-lg border shadow-lg drop-shadow-xl hover:bg-black/10"
    >
      <div className="h-80 w-full self-start cursor-pointer flex flex-col items-start justify-start">
        <div className="bg-black w-full rounded-t-lg">
          <img
            className="rounded-t-lg max-h-80 w-full self-start hover:opacity-75"
            src={movie.imgUrl}
            alt=""
          />
        </div>
      </div>
      <p className="w-full pb-2">{movie.title}</p>
    </div>
  );
}
export default CardImage;
